import { useEffect, useState } from "react";
import { RunSheet } from "@/components/run/RunSheet";
import { useOfficialWrite, type OfficialSheetProps } from "./shared";
interface Seat {
  seat_id: string;
  judge_number: number;
  holder: string | null;
  stale: boolean;
  claimed: boolean;
}
export function ExcuseSheet(
  props: OfficialSheetProps & { initialScope?: string; initialJudgeNumber?: number },
) {
  const { heat, competitionId, transport, onClose } = props;
  const [seats, setSeats] = useState<Seat[]>([]);
  const [seat, setSeat] = useState("");
  const [scope, setScope] = useState(props.initialScope ?? "all");
  const [reason, setReason] = useState("");
  const [loadError, setLoadError] = useState("");
  const { busy, error, write, execute, undo } = useOfficialWrite(props);
  useEffect(() => {
    let active = true;
    void transport
      .get<{ items: Seat[] }>(
        `/api/competitions/${competitionId}/seats${heat.area_id ? `?area_id=${heat.area_id}` : ""}`,
      )
      .then((s) => {
        if (active) {
          setSeats(s.items);
          if (props.initialJudgeNumber)
            setSeat(
              s.items.find((seat) => seat.judge_number === props.initialJudgeNumber)?.seat_id ?? "",
            );
        }
      })
      .catch((e) => setLoadError(e.message));
    return () => {
      active = false;
    };
  }, [competitionId, heat.area_id, transport, props.initialJudgeNumber]);
  return (
    <RunSheet title="Judges" close={onClose}>
      {(error || loadError) && <p role="alert">{error || loadError}</p>}
      {undo}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void write(() =>
            execute("excuse", {
              seat_id: seat,
              heat_id: heat.id,
              excused: true,
              scope,
              reason: reason.trim(),
            }),
          );
        }}
      >
        <fieldset>
          <legend>Judge</legend>
          {seats.map((s) => (
            <label className="run-toggle" key={s.seat_id}>
              <input
                type="radio"
                name="seat"
                value={s.seat_id}
                checked={seat === s.seat_id}
                onChange={() => setSeat(s.seat_id)}
              />
              Judge {s.judge_number} ·{" "}
              {s.claimed ? (s.stale ? "Connection stale" : "Seat claimed") : "Unclaimed"}
            </label>
          ))}
        </fieldset>
        <label>
          Scope
          <select value={scope} onChange={(e) => setScope(e.target.value)}>
            <option value="all">All</option>
            <option value="scores">Scores</option>
            <option value="placements">Placements</option>
          </select>
        </label>
        <label>
          Reason
          <textarea required value={reason} onChange={(e) => setReason(e.target.value)} />
        </label>
        <button className="run-primary" disabled={busy || !seat || !reason.trim()}>
          Excuse judge
        </button>
      </form>
    </RunSheet>
  );
}
